import { render, staticRenderFns } from "./InstockSel.vue?vue&type=template&id=2e0a715e&scoped=true&"
import script from "./InstockSel.vue?vue&type=script&lang=js&"
export * from "./InstockSel.vue?vue&type=script&lang=js&"
import style0 from "./InstockSel.vue?vue&type=style&index=0&id=2e0a715e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a715e",
  null
  
)

export default component.exports